import { render, staticRenderFns } from "./learning-live.vue?vue&type=template&id=f97602d2&"
import script from "./learning-live.vue?vue&type=script&lang=js&"
export * from "./learning-live.vue?vue&type=script&lang=js&"
import style0 from "./learning-live.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports